import { generateCodeVerifier, generateCodeChallenge } from "@/utils/pkceUtils";
import { ssoService } from "@/services/api/ssoService";

/**
 * Initiates the SSO login flow with PKCE and shopCode support.
 * Synchronous version for router guard usage.
 */
export function loginSSOSync() {
  let codeVerifier = sessionStorage.getItem("pkce_code_verifier");
  if (!codeVerifier) {
    codeVerifier = generateCodeVerifier();
    sessionStorage.setItem("pkce_code_verifier", codeVerifier);
  }
  // generateCodeChallenge is async, so we must use a workaround for sync guard:
  generateCodeChallenge(codeVerifier).then(codeChallenge => {
    const urlParams = new URLSearchParams(window.location.search);
    let shopCode = urlParams.get('shopId') || urlParams.get('shopCode');
    ssoService.getOpenIDRedirectUrl({ shopCode }).then(result => {
      const url = new URL(result.redirectUrl);
      url.searchParams.set('code_challenge', codeChallenge);
      url.searchParams.set('code_challenge_method', 'S256');
      window.location.replace(url.toString());
    });
  });
}

/**
 * Initiates the SSO login flow with PKCE and shopCode support.
 * @param {Object} [options]
 * @param {Function} [options.onRedirect] - Optional callback before redirect (for testing or logging)
 */
export async function loginSSO({ onRedirect } = {}) {
  // PKCE: generate code_verifier and code_challenge
  let codeVerifier = sessionStorage.getItem("pkce_code_verifier");
  if (!codeVerifier) {
    codeVerifier = generateCodeVerifier();
    sessionStorage.setItem("pkce_code_verifier", codeVerifier);
  }
  const codeChallenge = await generateCodeChallenge(codeVerifier);
  // Get shopCode from query params if present
  const urlParams = new URLSearchParams(window.location.search);
  let shopCode = urlParams.get('shopId') || urlParams.get('shopCode');
  // Get the base redirect URL from backend (no PKCE params)
  const result = await ssoService.getOpenIDRedirectUrl({ shopCode });
  // Append PKCE params to the redirect URL on the frontend
  const url = new URL(result.redirectUrl);
  url.searchParams.set('code_challenge', codeChallenge);
  url.searchParams.set('code_challenge_method', 'S256');
  if (onRedirect) onRedirect(url.toString());
  else window.location.href = url.toString();
}
